/*
 *@Description:日期工具库
 *@Author: zhengff
 *@Date: 2019-04-21 22:58:02
 */
import * as dayjs from 'dayjs'

const DATE = {
  reg: {
    yyyy: 'getFullYear',
    MM: 'getMonth',
    dd: 'getDate',
    HH: 'getHours',
    hh: 'getHours',
    mm: 'getMinutes',
    ss: 'getSeconds',
    ms: 'getMilliseconds'
  },
  format: function format(date, fmt) {
    fmt = fmt || 'yyyy-MM-dd HH:mm:ss'
    if (date) {
      var d = new Date(date),
        reg = this.reg
      for (var k in reg) {
        var v
        if (reg.hasOwnProperty(k)) {
          v = d[reg[k]]()
          if (k == 'MM') {
            v++
          }
          if (k != 'yyyy' && k != 'ms' && v < 10) {
            v = '0' + v
          }
          if(k === 'ms'){
            if(v < 100 && v >= 10){
              v = '0'+ v;
            } else if(v < 10){
              v = '00' + v
            }
          }          
          fmt = fmt.replace(k, v);          
        }
      }
      return fmt
    } else {
      return ''
    }
  },
  parse: function(str) {
    //根据日期字符串转换成日期
    var regEx = new RegExp('\\-', 'gi')
    str = str.replace(regEx, '/')
    var milliseconds = Date.parse(str)
    var dependedDate = new Date()
    dependedDate.setTime(milliseconds)
    return dependedDate
  },
  fromNow: function(date) {
    if (!(date instanceof Date)) {
      date = new Date(date)
    }
    var now = new Date(),
      pass = now - date
    if (pass <= 5 * 60 * 1000) {
      return '刚刚'
    } else if (pass <= 30 * 60 * 1000) {
      return Math.round((pass * 1.0) / 60000) + '分钟前'
    } else {
      return this.format(date, 'yyyy-MM-dd HH:mm:ss')
    }
  },
  calcDate: function(date1, date2) {
    var date3 = date2 - date1

    var days = Math.floor(date3 / (24 * 3600 * 1000))

    var leave1 = date3 % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))

    var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))

    var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
    var seconds = Math.round(date3 / 1000)
    return {
      leave1,
      leave2,
      leave3,
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    }
  },
  GetDateStr: function(AddDayCount) {
    var dd = new Date()
    dd.setDate(dd.getDate() + AddDayCount) //获取AddDayCount天后的日期
    var y = dd.getFullYear()
    var m =
      dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1 //获取当前月份的日期，不足10补0
    var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate() //获取当前几号，不足10补0
    return y + '-' + m + '-' + d
  },
  /*
   *@name: 日期转换星期
   *@param:{type} 
   *@description:
   *@return:
   *@author: panlua
   *@date: 2019-05-09 11:01:04
  */
  dateChangeWeek: function (data) {
    let week = dayjs(data).day()
    return week === 0 ? 7 : week
  },
  dayjs(data){
    return dayjs(data);
  },
  //将时间戳转换成'yyyy-MM-dd HH:mm:ss格式
  TimeStamp(val){
    if(!val){
      return '';
    }
    var date = new Date(parseInt(val));
    var tt = [date.getFullYear(), ((date.getMonth()+1)<10?'0'+(date.getMonth()+1):date.getMonth()+1), (date.getDate()<10?'0'+date.getDate():date.getDate())].join('-') + '  ' +[(date.getHours()<10?'0'+date.getHours():date.getHours()), (date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()), (date.getSeconds()<10?'0'+date.getSeconds():date.getSeconds())].join(':');
    return tt
  }
}
export default DATE
